import {useTheme} from "next-themes"
import {toast as sonnerToast, Toaster as Sonner, ToasterProps} from "sonner"
import React from 'react';

const Toaster = ({...props}: ToasterProps) => {
    const {theme = "system"} = useTheme()

    return (
        <Sonner
            theme={theme as ToasterProps["theme"]}
            className="toaster group"
            style={
                {
                    "--normal-bg": "var(--popover)",
                    "--normal-text": "var(--popover-foreground)",
                    "--normal-border": "var(--border)",
                } as React.CSSProperties
            }
            {...props}
        />
    )
}

const toast = {
    ...sonnerToast,
    error: (message: string) => {
        sonnerToast.error(message, {
            style: {
                background: 'red',
                color: 'white'
            }
        });
    },
    success: (message: string) => {
        sonnerToast.success(message, {
            style: {
                background: 'green',
                color: 'white'
            }
        });
    }
}

export {Toaster, toast}
